/**
 * ImportFileChips — chips para los ficheros Excel/CSV adjuntos al chat (canal de
 * importación). Estado: subiendo → listo → error. No tienen worker async ni
 * destino (eso lo resuelve la tool importar_tabla en el backend tras enviar).
 */

import PropTypes from 'prop-types';
import { Table2, Loader2, CheckCircle2, AlertCircle, X } from 'lucide-react';

function StatusIcon({ status }) {
  if (status === 'error') return <AlertCircle className="h-3.5 w-3.5 text-destructive" />;
  if (status === 'ready') return <CheckCircle2 className="h-3.5 w-3.5 text-success" />;
  return <Loader2 className="h-3.5 w-3.5 animate-spin text-muted-foreground" />;
}
StatusIcon.propTypes = { status: PropTypes.string };

export default function ImportFileChips({ files = [], onRemove, variant = 'default' }) {
  if (!files.length) return null;
  const chipBg = variant === 'canvas'
    ? 'bg-white/55 dark:bg-white/10 backdrop-blur-md border-white/50 dark:border-white/10'
    : 'border-border bg-background';
  return (
    <div className="mb-2 flex flex-wrap gap-2">
      {files.map((f) => (
        <div
          key={f.id}
          className={`flex items-center gap-1.5 rounded-lg border px-2 py-1 text-xs ${chipBg}`}
          title={f.error || f.filename}
        >
          <Table2 className="h-3.5 w-3.5 shrink-0 text-emerald-600" />
          <span className="max-w-[140px] truncate">{f.filename}</span>
          <StatusIcon status={f.status} />
          {onRemove && (
            <button
              type="button"
              onClick={() => onRemove(f.id)}
              aria-label={`Quitar ${f.filename}`}
              className="ml-0.5 inline-flex h-4 w-4 items-center justify-center rounded-full text-muted-foreground hover:bg-muted hover:text-foreground"
            >
              <X className="h-2.5 w-2.5" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
}

ImportFileChips.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    filename: PropTypes.string,
    status: PropTypes.string,
    error: PropTypes.string,
  })),
  onRemove: PropTypes.func,
  variant: PropTypes.oneOf(['default', 'canvas']),
};
